import styled from 'styled-components';

export const NoAccessContent = styled.h4`
  text-align: center;
  font-size: 16px;
  line-height: 20px;
  max-width: 460px;
`;
